const address = {
  'address.title': 'Управление адресами',
  'address.address': 'Адрес доставки',
  'address.address.placeholder': 'Выберите адрес доставки',
  'address.add': 'Добавить',
  'address.addAddress': 'Новый адрес',
  'address.edit': 'Редактировать',
  'address.editAddress': 'Редактирование адреса',
  'address.delete': 'Удалить',
  'address.deleteAddress': 'Удаление адреса',
  'address.default': 'По умолчанию',
  'address.defaultAddress': 'Адрес по умолчанию',
  'address.setDefault': 'Сделать основным',
  'address.setDefaultAddress': 'Установить как основной',
  'address.switch': 'Сменить',
  'address.switchAddress': 'Смена адреса',

  'address.country': 'Страна',
  'address.country.placeholder': 'Введите страну',
  'address.country.maxLength': 'Название страны не должно превышать {total} символов',
  'address.state': 'Область/Штат',
  'address.state.placeholder': 'Введите область/штат',
  'address.state.maxLength': 'Название области не должно превышать {total} символов',
  'address.city': 'Город',
  'address.city.placeholder': 'Введите город',
  'address.city.maxLength': 'Название города не должно превышать {total} символов',
  'address.street': 'Улица',
  'address.street.placeholder': 'Введите улицу',
  'address.street.maxLength': 'Название улицы не должно превышать {total} символов',
  'address.detail': 'Подробный адрес',
  'address.detail.placeholder': 'Введите подробный адрес',
  'address.detail.maxLength': 'Адрес не должен превышать {total} символов',

  'address.recipient_name': 'Получатель',
  'address.recipient_name.placeholder': 'Введите имя получателя',
  'address.recipient_name.maxLength': 'Имя получателя не должно превышать {total} символов',
  'address.recipient_name.minLength': 'Имя получателя должно быть не менее {total} символов',
  'address.recipient_name.pattern': 'Допустимы только китайские/английские буквы и пробелы',

  'address.phone': 'Контактный телефон',
  'address.phone.placeholder': 'Пример: +7 900 123-45-67',
  'address.phone.maxLength': 'Телефон не должен превышать {total} символов',
  'address.phone.pattern': 'Введите корректный номер с кодом страны',

  'address.postal_code': 'Почтовый индекс',
  'address.postal_code.placeholder': 'Введите индекс',
  'address.postal_code.maxLength': 'Индекс не должен превышать {total} символов',
  'address.postal_code.pattern': 'Введите корректный почтовый индекс',

  'address.updateSuccess': 'Адрес обновлён',
  'address.createSuccess': 'Адрес добавлен',
  'address.deleteSuccess': 'Адрес удалён',
  'address.setDefaultSuccess': 'Основной адрес установлен',

  'address.confirmDelete': 'Удалить этот адрес?',
};

export default address;
